import { render, staticRenderFns } from "./AlertKeyword.vue?vue&type=template&id=36524166&scoped=true"
import script from "./AlertKeyword.vue?vue&type=script&lang=js"
export * from "./AlertKeyword.vue?vue&type=script&lang=js"
import style0 from "./AlertKeyword.vue?vue&type=style&index=0&id=36524166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36524166",
  null
  
)

export default component.exports